import { createSelector } from "reselect";

import { ReportSlice } from "@sportal/api/reports";

import { RootState } from "../../../root.reducer";
import { getReports } from "../../../root.selectors";
import { DataKeys } from "../../../../helpers/reports.helper.types";
import { WidgetsSlice } from "../../reports.types";

const getWidgets = (state: RootState): WidgetsSlice =>
  getReports(state).widgets;

export const getWidgetData = (widget: DataKeys) =>
  createSelector(
    [getWidgets],
    (widgets: WidgetsSlice): ReportSlice[] => widgets[widget].data
  );

export const isWidgetLoading = (widget: DataKeys) =>
  createSelector(
    [getWidgets],
    (widgets: WidgetsSlice): boolean => widgets[widget].isLoading
  );

export const isWidgetLoadFailed = (widget: DataKeys) =>
  createSelector(
    [getWidgets],
    (widgets: WidgetsSlice): boolean => !!widgets[widget].error
  );
